import api from "utils/api";

export const updateBasketCount = () => {
  return api.basketCount();
};

export const checkInBasket = (assetKey: string) => {
  return api.checkInBasket(assetKey);
};
